module.exports = __webpack_public_path__ + "img/nav-acts.91af8ee5.svg";